/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Duplicate_Disabled_GiftInputs */

const vi_order_duplicate_disabled_gift = /** @type {(inputs: Order_Duplicate_Disabled_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn quà từ website / Mini App không sao chép được — sẽ mất lời nhắn, ẩn giá và ship người đặt đã trả trước`)
};

/**

* @param {Order_Duplicate_Disabled_GiftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_duplicate_disabled_gift = /** @type {((inputs?: Order_Duplicate_Disabled_GiftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Duplicate_Disabled_GiftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_duplicate_disabled_gift(inputs)
});